export const theme = {
  color: {
    whisper: "#F5F5FA",
    pattensBlue: "#D6E4FF",
    scienceBlue: "#0044CC",
    mystic: "#E4E6F0",
    silver: "#C4C4C4",
    snuff: "#DDDDEE",
    waterloo: "#7E839A",
    white: "#FFFFFF",
    woodsmoke: "#18181B",
    black: "#000000",
    stormgrey: "#74788B",
    lineargradient:
      "linear-gradient(270deg, #000000 14.11%, rgba(0, 0, 0, 0.873268) 15.08%, rgba(0, 0, 0, 0.720529) 16.51%, rgba(0, 0, 0, 0.294577) 19.99%, rgba(0, 0, 0, 0.159921) 21.88%, rgba(0, 0, 0, 0) 25.68%), linear-gradient(90deg, #000000 13.6%, rgba(0, 0, 0, 0.984059) 14.58%, rgba(0, 0, 0, 0.967732) 15.44%, rgba(0, 0, 0, 0.865569) 16.3%, rgba(0, 0, 0, 0.230315) 22.87%, rgba(0, 0, 0, 0) 26.64%), linear-gradient(180deg, #000000 0%, rgba(0, 0, 0, 0.689555) 4.66%, rgba(0, 0, 0, 0.439033) 9.34%, rgba(0, 0, 0, 0.20628) 15.16%, rgba(0, 0, 0, 0) 24.22%), linear-gradient(189.44deg, rgba(0, 0, 0, 0) 58.48%, rgba(0, 0, 0, 0.106473) 63.17%, rgba(0, 0, 0, 0.235359) 68.85%, rgba(0, 0, 0, 0.492821) 78.08%, rgba(0, 0, 0, 0.740286) 85.86%, #000000 92.87%)",
  },
  breakpoint: {
    small: 480,
    medium: 767,
    mediumBig: 889,
    large: 1024,
    extraLarge: 1199,
    bigest: 1389,
  },
};

export const boxShadow = "0px 4px 12px rgba(186, 199, 213, 0.5)";

export const hoverBoxShadow = "0 0 11px rgba(33, 33, 33, 0.2)";

export const borderRadius = "5px";
